import fetch, {proxyService} from "./Interceptor"
import {recoverContentRead} from './contentReadRecovery'

// opts.useProxy : route l'appel via le BFF Next same-origin (pages/api/[...path])
// au lieu de taper l'API en direct. À utiliser UNIQUEMENT pour les appels qui
// s'appuient sur l'identité du compte connecté (paiement avec config.contact,
// soumission de formulaire avec identity.id → garde A7). Le cookie HttpOnly part
// alors automatiquement et le BFF l'injecte en Bearer. Les appels anonymes
// gardent le défaut (API directe, zéro surcharge).
function pick(opts) {
    return opts && opts.useProxy ? proxyService : fetch
}

const defaultService = {}

defaultService.get = function (url, params, opts) {
    const request = () => pick(opts).request({url, method: 'get', params, signal:opts?.signal})
    if (typeof window === 'undefined' || opts?.useProxy) return request()
    return recoverContentRead(request, url, {signal:opts?.signal,
        canRetry:()=>navigator.onLine !== false && document.visibilityState !== 'hidden'})
}

defaultService.post = function (url, data, opts) {
    return pick(opts).request({url, method: 'post', data})
}

export default defaultService
